import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
// import { isBidDepotProject } from '../../../utils'
import { IconButton, InputBase, makeStyles, Paper } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
        backgroundColor: '#F2F2F7',
    },
    input: {
        flex: 1,
        padding: '2px 4px',
        color: '#49454f',
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}))

const HeaderSearchComponent = (props) => {
    const classes = useStyles()
    const [searchValues, setSearchValues] = useState({
        searchbar: '',
        zipcode: '',
        miles: '',
        category: [],
        cond: [],
        loc: [],
        edate: [],
        slimit: 50,
        sort: 6,
        page: 1,
    })
    const handleChange = (e) =>
        setSearchValues({ ...searchValues, [e.target.name]: e.target.value })
    let history = useHistory()

    const handleClick = (e) => {
        // e.preventDefault()
        history.push(
            `/search?q=${searchValues.searchbar}&z=${searchValues.zipcode}&m=${
                searchValues.miles
            }&cat=${
                searchValues.category.length > 0 ? searchValues.category.join(',') : ''
            }&view=0&loc=${searchValues?.loc}&cond=${searchValues?.cond}&edate=${
                searchValues?.edate
            }&sort=${searchValues?.sort}&slimit=${searchValues?.slimit}&page=${searchValues?.page}`,
        )
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        console.log('search page ---', params.get('page'))
        setSearchValues({
            ...searchValues,
            searchbar: params.get('q') ? params.get('q') : '',
            zipcode: params.get('z') ? params.get('z') : '',
            miles: params.get('m') ? params.get('m') : '',
            category: params.get('cat') ? params.get('cat').split(',') : '',
            cond: params.get('cond') ?? '',
            loc: params.get('loc') ?? '',
            edate: params.get('edate') ?? '',
            slimit: params.get('slimit') ?? 50,
            sort: params.get('sort') ?? '',
            page: params.get('page') ?? 1,
        })
    }, [])

    const isBidDepotProject = document.querySelector('body').classList.contains('BidAuction')
    const isBargainsProject = document.querySelector('body').classList.contains('bargains')

    return (
        <form
            className="nav-standard-top-area-search"
            onSubmit={(e) => {
                e.preventDefault()
                handleClick(e) // Call your custom search logic
            }}
        >
            <div className="nav-standard-top-area-search-inner">
                {isBidDepotProject && !isBargainsProject ? (
                    <Paper className={classes.root}>
                        {window.screen.width > 1024 ? (
                            <IconButton
                                type="submit"
                                className={`${classes.iconButton} lt`}
                                aria-label="menu"
                            >
                                View All Items
                                {/* <span className="material-icons" onClick={handleClick}>
                                    menu
                                </span> */}
                            </IconButton>
                        ) : (
                            <IconButton
                                type="submit"
                                className={classes.iconButton}
                                aria-label="search"
                            >
                                <span className="material-icons" onClick={handleClick}>
                                    search
                                </span>
                            </IconButton>
                        )}
                        <InputBase
                            className={`nav-standard-top-area-search-textInput ${classes.input} ${
                                window.screen.width > 1024 ? 'rt' : "'"
                            }`}
                            placeholder="Search Items"
                            inputProps={{ 'aria-label': 'search google maps' }}
                            type="search"
                            onChange={handleChange}
                            name="searchbar"
                            value={searchValues.searchbar}
                        />
                        {window.screen.width > 1024 ? (
                            <IconButton
                                type="submit"
                                className={classes.iconButton}
                                aria-label="search"
                            >
                                <span className="material-icons" onClick={handleClick}>
                                    search
                                </span>
                            </IconButton>
                        ) : (
                            ''
                        )}
                    </Paper>
                ) : (
                    <>
                        <div>
                            {/* <span className="material-icons srchIcon" onClick={handleClick}>
                                search
                            </span> */}
                            <input
                                type="search"
                                onChange={handleChange}
                                name="searchbar"
                                value={searchValues.searchbar}
                                className="nav-standard-top-area-search-input open-sans"
                                placeholder="Search Inventory"
                            />
                        </div>
                        <button
                            onClick={handleClick}
                            className="lin lin-magnifier nav-standard-top-area-search-sumbit searching-inventory"
                        >
                            <span className="material-icons srchIcon">search</span>
                        </button>
                    </>
                )}
            </div>
        </form>
    )
}

export default HeaderSearchComponent
